import { AxiosError } from "axios";
import readDataFromBlobAsync from "./readDataFromBlobAsync";

// обработчик ошибок RTK + axios
const handleErrorRTKAndAxiosAsync = async (error: unknown) => {
	if (!error) return error; // возвращаем как есть

	if (error instanceof AxiosError) {
		if (error.response?.data instanceof Blob) {
			try {
				// читаем файл
				const data = await readDataFromBlobAsync({ blob: error.response?.data, readingOption: "readAsText" });
				return data; // данные файла
			} catch (error) {
				return error; // ошибка чтения файла
			}
		} else {
			return error; // ошибка axios
		}
	} else {
		return error; // неизвестная ошибка
	}
};

export default handleErrorRTKAndAxiosAsync;
